<div class="as-modal-container">
    <div class="icon-container">
        <mat-icon mat-dialog-close svgIcon="ic-close-green"></mat-icon>
    </div>
    <div class="texts">
        <p class="as-font as-font-16 as-font-blackish as-font-bold">{{ 'CLUB.alertText1' | translate }}</p>
        <p class="as-font as-font-16 as-font-blackish">{{ 'CLUB.alertText2' | translate }}</p>
    </div>
    <div class="buttons-container">
        <button (click)="close(false)" mat-flat-button class="" color="accent">{{ 'GENERAL.continue' | translate }}</button>
        <button (click)="close(true)" color="accent">{{ 'CLUB.canje' | translate }}</button>
    </div>
</div>